module.exports = __webpack_public_path__ + "assets/navbar-logo.06910a0d660fdc7569b9f899f973e471.svg";